import { createAction } from 'redux-actions';
import {
  closeSocketClientRequest,
  removeUserFromRoom,
} from 'api/statement-socket-client-api';

export const setStatementSocketClient = createAction(
  'SET_STATEMENT_SOCKET_CLIENT',
);

export const initStatementSocketClient = createAction(
  'INIT_STATEMENT_SOCKET_CLIENT',
);

export const clearSocketClientInStore = createAction(
  'CLEAR_STATEMENT_SOCKET_CLIENT',
);

export const stopSocketConnection = createAction('STOP_SOCKET_CONNECTION');

export const initStatementSocketClientAction =
  ({ revisionId, projectId, currentUserId }) =>
    async (dispatch, getState) => {
      const { data: { currentUser } = {} } = getState();
      const { data: { projectToGeoMap } = {} } = currentUser || {};
      const geoCode = projectId
        ? (projectToGeoMap.get(`${projectId}`) || {}).geoCode
        : null;
      await dispatch(
        initStatementSocketClient({
          revisionId,
          projectId,
          currentUserId,
          geoCode,
          dispatch,
          currentUser,
        }),
      );
    };

export const closeSocketClient =
  ({ revisionId, projectUserIds, projectId }) =>
    async (dispatch, getState) => {
      try {
        await removeUserFromRoom({
          revisionId,
          projectUserIds: Object.keys(projectUserIds),
          projectId,
        });
      } catch (error) {
        console.error(error);
      }
      dispatch(stopSocketConnection());
      dispatch(clearSocketClientInStore());
    };
